import { AvailabilityChange, CustomFieldsChanges, SimpleChange } from "./changelog";
import { Id } from "./id";

export enum NotificationStatus {
  Read = "read",
  Unread = "unread"
}

export type NotificationChanges = {
  name?: SimpleChange;
  description?: SimpleChange;
  availability?: AvailabilityChange;
  customFields?: CustomFieldsChanges;
};

export type NotificationMetadata = {
  changes?: NotificationChanges;
  activityName?: string;
  parentActivityName?: string;
  templateKey?: string;
  important: boolean;
};

export enum NotificationCategoryType {
  FileGenerated = "file_generated",
  Message = "message",
  ActivityTagChanged = "activity_tag_changed",
  RoleClosed = "role_closed",
  RoleExpiring = "role_expiring",
  RoleFilled = "role_filled",
  RoleFilledForReviewer = "role_filled_for_reviewer",
  VacancyClosed = "vacancy_closed",
  InterestedRoleClosed = "interested_role_closed",
  EngagementScenarioShared = "engagement_scenario_shared",
  OwnerRole = "owner_role",
  OwnerEngagement = "owner_engagement",
  Assignee = "assignee",
  EngagementAssigned = "engagement_assigned",
  AssigneeRemoved = "assignee_removed",
  HelpRequested = "help_requested",
  ShortlistCreated = "shortlist_created",
  ShortlistAssigned = "shortlist_assigned",
  NewRoleAccepted = "new_role_accepted",
  NewRoleDeclined = "new_role_declined",
  ExceptionApproved = "exception_approved",
  ExceptionRejected = "exception_rejected",
  BookingApprovalRequests = "booking_approval_requests",
  BookingReviewed = "booking_reviewed",
  BookingCategoryChanged = "booking_category_changed"
}

export type Notification = {
  activityId: number;
  body: string;
  categoryType: NotificationCategoryType;
  createdAt: string;
  id: number;
  pictureUrl: string | null;
  status: NotificationStatus;
  targetId: number;
  targetType: string;
  title: string;
  urlAddress: string;
  metadata?: NotificationMetadata;
};

export enum NotificationGroupType {
  None = "none", // "none" is just for UI
  Category = "category",
  RoleId = "role_id",
  EngagementId = "engagement_id"
}

export type NotificationGroup = {
  identifier: Id;
  name: string;
  notificationsCount: number;
};
